jQuery(document).ready(function($) {
    // Process each submenu
    $(".secondary_menu").each(function() {
        var $figure = $(this).find("figure.menu-thumbnails");
        var $menuItems = $(this).find("ul.sub-menu > li");
        // Add thumbnails to the figure and store references
        $menuItems.each(function() {
            var $menuItem = $(this);
            var thumbnailUrl = $menuItem.data("thumbnail");
            var itemTitle = $menuItem.find("a").text();
            var itemId = $menuItem.data("item-id");
            // Only add if there is a thumbnail
            if (thumbnailUrl) {
                // Create image with data attribute to link back to menu item
                var $img = $('<img src="' + thumbnailUrl + '" alt="' + itemTitle + '" class="menu-thumbnail" data-item-id="' + itemId + '">');
                $figure.append($img);
                // Store reference to the image on the menu item for quick access
                $menuItem.data("thumbnail-element", $img);
            }
        });
        // Add hover events to menu items
        $menuItems.hover(
            function() {
                // On hover in
                var $menuItem = $(this);
                var itemId = $menuItem.data("item-id");
                // Find the corresponding thumbnail and add active class
                $figure.find('img[data-item-id="' + itemId + '"]').addClass("active");
            },
            function() {
                // On hover out
                var $menuItem = $(this);
                var itemId = $menuItem.data("item-id");
                // Find the corresponding thumbnail and remove active class
                $figure.find('img[data-item-id="' + itemId + '"]').removeClass("active");
            }
        );
        // Set the first image as active by default
        $figure.find("img.menu-thumbnail").first().addClass("active");
        // When not hovering any menu item, show the first image as active
        $menuItems.parent("ul.sub-menu").hover(
            function() {
                // Mouse enters the submenu - do nothing
            },
            function() {
                // Mouse leaves the submenu - reset to first image active
                $figure.find("img.menu-thumbnail").removeClass("active");
                $figure.find("img.menu-thumbnail").first().addClass("active");
            }
        );
    });
});